import {Cureus} from '../Cureus';

Cureus.HomepageHeros = {};

//= require_tree ./HomepageHeros